<!--This file is part of sisdai-proyecto-base.-->

<!--sisdai-proyecto-base is free software: you can redistribute it and/or modify-->
<!--it under the terms of the GNU Lesser General Public License as published by the-->
<!--Free Software Foundation, either version 3 of the License, or-->
<!--(at your option) any later version.-->

<!--sisdai-proyecto-base is distributed in the hope that it will be useful,-->
<!--but WITHOUT ANY WARRANTY; without even the implied warranty of-->
<!--MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Lesser General-->
<!--Public License for more details.-->

<!--You should have received a copy of the GNU Lesser General Public License along-->
<!--with sisdai-proyecto-base. If not, see <https://www.gnu.org/licenses/>.-->

<script setup>
import { ref, onBeforeUnmount, onMounted } from 'vue'
import VideoYoutube from '@/components/ui/VideoYoutube.vue'
import TemporalTarjetasDeslizables from '@/components/ui/TemporalTarjetasDeslizables.vue'

function calHeight() {
  const innerheight = window.innerHeight / 100
  document
    .querySelector(':root')
    .style.setProperty('--vh', `${innerheight.toString()}px`)
}

calHeight()

onMounted(() => {
  window.addEventListener('resize', calHeight)
  cargarDatos()
})

onBeforeUnmount(() => {
  window.addEventListener('resize', calHeight)
})

const cdnArchivos = process.env.VUE_APP_CDN_ARCHIVOS
const url = `${cdnArchivos}/index/tarjetas_inicio.json`

const transformacion = ref([])
const coordinacion = ref([])

const cargarDatos = async () => {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error('Error al cargar archivo')
    }

    const tarjetas_inicio = await response.json()

    transformacion.value = tarjetas_inicio[0].comparativas
    coordinacion.value = tarjetas_inicio[1].comparativas
  } catch (error) {
    console.error(error)
  }
}
</script>

<template>
  <main id="principal">
    <div class="portada">
      <img
        class="portada-imagen"
        :src="`${cdnArchivos}/index/portada.png`"
        alt=""
      />
      <div class="portada-degradado">
        <hgroup class="portada-cuerpo">
          <h1 class="portada-titulo">Portal de información</h1>
          <p class="portada-subtitulo">
            Una iniciativa del Conahcyt para abonar a la transparencia y
            rendición de cuentas
          </p>
        </hgroup>
      </div>
    </div>

    <section class="contenedor m-y-5">
      <h2 class="ancho-lectura p-t-5">
        Transformación administrativa del Consejo
      </h2>
      <p class="ancho-lectura">
        En este portal se pone a disposición pública la información que sustenta
        los cambios más significativos que derivaron de la implementación de la
        nueva política en Humanidades, Ciencias, Tecnologías e Innovación
        (HCTI).
      </p>
      <p class="ancho-lectura">
        Las personas que lo consulten tendrán acceso a comparaciones sobre lo
        que formula y conduce el nuevo Consejo Nacional de Humanidades, Ciencias
        y Tecnologías (Conahcyt) en contraste con la estrategia del viejo
        Conacyt.
      </p>
      <p class="ancho-lectura">
        En este primer apartado es posible explorar comparaciones de la
        transformación administrativa, desde el marco legal de la nueva ley de
        HCTI hasta los extintos fideicomisos.
      </p>
      <div class="flex flex-contenido-centrado">
        <div class="columna-12">
          <VideoYoutube
            videoId="pOP4c9Skf68"
            videoTitulo="Ir a ver video acerca de La Ley General en Materia de HCTI"
            videoUrl="https://www.youtube.com/watch?v=pOP4c9Skf68"
          />
        </div>
      </div>

      <TemporalTarjetasDeslizables
        :descripcion="obj.descripcion"
        :comparativa="obj.comparativa"
        :key="i"
        v-for="(obj, i) in transformacion"
      />
    </section>

    <section class="contenedor m-y-5">
      <h2 class="ancho-lectura p-t-5">
        Transformación de la política pública de HCTI
      </h2>

      <div class="flex flex-contenido-centrado">
        <div class="columna-12">
          <VideoYoutube
            videoId="4qatPyQtaZA"
            videoTitulo="Ir a ver video acerca de Qué son los Pronaces "
            videoUrl="https://www.youtube.com/watch?v=4qatPyQtaZA"
          />
        </div>
      </div>
      <TemporalTarjetasDeslizables
        :descripcion="obj.descripcion"
        :comparativa="obj.comparativa"
        :key="i"
        v-for="(obj, i) in coordinacion"
      />
    </section>

    <aside class="contenedor a11y-simplificada-contenedor p-y-5">
      <div class="flex flex-contenido-centrado">
        <div class="columna-8">
          <div class="tarjeta tarjeta-horizontal">
            <img
              class="tarjeta-imagen"
              :src="`${cdnArchivos}/index/presupuesto.png`"
              alt=""
            />
            <div class="tarjeta-cuerpo">
              <p class="tarjeta-titulo">Presupuesto</p>
              <p>
                Conoce cómo se ejerce el Presupuesto de Egresos de la Federación
                en el ramo destinado a Humanidades, Ciencias, Tecnologías e
                Innovación.
              </p>
            </div>
            <div class="tarjeta-pie">
              <router-link
                class="boton boton-primario boton-chico"
                to="/presupuesto"
              >
                Ir a Presupuesto
              </router-link>
            </div>
          </div>
        </div>
        <div class="columna-8">
          <div class="tarjeta tarjeta-horizontal">
            <img
              class="tarjeta-imagen"
              :src="`${cdnArchivos}/index/descargas.png`"
              alt=""
            />
            <div class="tarjeta-cuerpo">
              <p class="tarjeta-titulo">Descargas</p>
              <p>
                Para conocer detalles de las fuentes de las descargas y otras
                notas, visita esta sección.
              </p>
            </div>
            <div class="tarjeta-pie">
              <router-link
                class="boton boton-primario boton-chico"
                to="/descargas"
              >
                Ir a Descargas
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </main>
</template>
